import { render, staticRenderFns } from "./PriceFacet.vue?vue&type=template&id=7ac6c4c1&scoped=true"
import script from "./PriceFacet.vue?vue&type=script&lang=js"
export * from "./PriceFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac6c4c1",
  null
  
)

export default component.exports